import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PageHeader } from 'components'
import React from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { IPageProps } from 'types'

const NotFoundPage = ({ title }: IPageProps) => {
    const navigate = useNavigate()
    return (
        <div>
            <PageHeader title={title} />
            <Row>
                <Col>
                    <Alert variant='info border'>
                        This page no longer exists. Please click the button below to return to your previous page.
                    </Alert>
                </Col>
                <Col>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button variant='primary' className='mt-1' onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={['fas', 'arrow-circle-left']} /> Return
                    </Button>
                </Col>
                <Col>
                </Col>
            </Row>

        </div >
    )
}
export default NotFoundPage